import { gridPageCountSelector, gridPageSelector, useGridApiContext, useGridSelector } from "@mui/x-data-grid"

import { Pagination } from "../Pagination"

export function DataGridPagination() {
    const apiRef = useGridApiContext()
    const page = useGridSelector(apiRef, gridPageSelector)
    const pageCount = useGridSelector(apiRef, gridPageCountSelector)

    return <Pagination
        page={page + 1}
        count={pageCount}
        onChange={(_event, newPage) => apiRef.current.setPage(newPage - 1)} />
}
